import { SingleInputDateRangeField as BaseSingleInputDataRangeField } from "@mui/x-date-pickers-pro";
import { PickerTextField } from "./PickerTextField.tsx";
import type { SingleInputDateRangeFieldProps as MuiSingleInputDateRangeFieldProps } from "@mui/x-date-pickers-pro";
import type { Dayjs } from "dayjs";

import React, { forwardRef, type MouseEvent } from "react";

export type SingleInputDateRangeFieldProps =
  MuiSingleInputDateRangeFieldProps<Dayjs> & {
    onCalendarClick?: (e: MouseEvent<HTMLDivElement>) => void;
    onClearClick?: (e: MouseEvent<HTMLDivElement>) => void;
  };

export const SingleInputDateRangeField = forwardRef(
  (props: SingleInputDateRangeFieldProps, ref: any) => {
    return (
      <BaseSingleInputDataRangeField
        ref={ref}
        {...props}
        slots={{
          ...props.slots,
          textField: PickerTextField,
        }}
        slotProps={{
          ...props.slotProps,
          textField: {
            ...props.slotProps?.textField,
            disabled: props.disabled, // otherwise input won't be disabled
          },
        }}
      />
    );
  },
);

Object.assign(SingleInputDateRangeField, {
  fieldType: "single-input",
});
